import { render, staticRenderFns } from "./DayStatistics.vue?vue&type=template&id=7845d717&scoped=true&"
import script from "./DayStatistics.vue?vue&type=script&lang=js&"
export * from "./DayStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DayStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845d717",
  null
  
)

export default component.exports